var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","width":"10px"}},[_c('div',{staticClass:"medium mb-5 mt-5",class:_vm.getColor})])
}
var staticRenderFns = []

export { render, staticRenderFns }